import { cn } from '@/lib/utils';

interface EmptyStateProps {
  institutionName: string;
  fullHeight?: boolean;
}

export function EmptyState({ institutionName, fullHeight }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8 text-center',
        fullHeight ? 'h-full' : 'h-[600px]'
      )}
    >
      <p className="text-muted-foreground">
        No correspondence yet with {institutionName}
      </p>
    </div>
  );
}
